import { Component } from '@angular/core';

@Component({
  selector: 'app-badge-interactive-demo',
  templateUrl: './badge-interactive-demo.component.html',
  styleUrls: ['./badge-interactive-demo.component.scss'],
})
export class BadgeInteractiveDemoComponent {}
